// Reposição · forecast 30d + min/max + sugestão de compra
import { db } from '../client.js';
import { escapeHTML, QTY, BRL, NUM, SHORT } from '../shared.js';

export async function viewReposicao($c) {
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">FORECAST E REPOSIÇÃO</div>
        <h1>Min/max <strong>e sugestão de compra</strong></h1>
        <p class="lead">Cálculo automático: demanda diária (90d) × lead-time + safety stock (30%). Atualiza diário às 04h BRT. SKUs abaixo do mínimo aparecem primeiro.</p>
      </div>
      <div class="page-head-actions">
        <button class="btn" id="btn-recalc">⟳ Recalcular agora</button>
      </div>
    </header>

    <div class="stats" id="rep-stats"></div>

    <div class="card">
      <div class="card-head">
        <h2>SKUs por situação <span class="count" id="rep-count">…</span></h2>
        <select id="rep-filter">
          <option value="">todos</option>
          <option value="critico">críticos (< 50% mínimo)</option>
          <option value="alerta">alerta (< mínimo)</option>
          <option value="atenção">atenção (< 120% mín)</option>
          <option value="ok">OK</option>
          <option value="A">classe A</option>
          <option value="B">classe B</option>
          <option value="C">classe C</option>
        </select>
      </div>
      <div id="rep-list"></div>
    </div>

    <div class="grid-2 mt-md">
      <div class="card">
        <div class="card-head"><h2>Como o sistema calcula</h2></div>
        <table class="tbl">
          <tbody>
            <tr><td><span class="mono-inline">demanda_diaria</span></td><td>SUM(saidas 90d) / 90</td></tr>
            <tr><td><span class="mono-inline">forecast_30d</span></td><td>demanda_diaria × 30</td></tr>
            <tr><td><span class="mono-inline">safety_stock</span></td><td>30% × demanda × lead-time</td></tr>
            <tr><td><span class="mono-inline">qtd_minima</span></td><td>demanda × lead-time + safety</td></tr>
            <tr><td><span class="mono-inline">qtd_maxima</span></td><td>qtd_minima × 2</td></tr>
            <tr><td><span class="mono-inline">qtd_repor</span></td><td>max(0, qtd_maxima − saldo_atual)</td></tr>
          </tbody>
        </table>
      </div>
      <div class="card">
        <div class="card-head"><h2>Próxima evolução</h2></div>
        <ul class="clean">
          <li>Lead-time por fornecedor (Juniper US ≠ distribuidor BR)</li>
          <li>Sazonalidade XY (não só média)</li>
          <li>Stockout cost vs holding cost (otimização)</li>
          <li>Avisar Binário automático quando crítico</li>
          <li>Sugerir lote econômico (EOQ)</li>
        </ul>
      </div>
    </div>
  `;

  document.getElementById('btn-recalc').addEventListener('click', async () => {
    const btn = document.getElementById('btn-recalc');
    btn.disabled = true; btn.textContent = '⟳ recalculando…';
    try {
      const { data } = await db.rpc('recalcular_forecast_minmax');
      alert(`✓ ${data.skus_recalculados} SKUs · ${data.skus_abaixo_minimo} abaixo do mínimo`);
      viewReposicao($c);
    } catch (e) { alert('Erro: ' + e.message); btn.disabled = false; btn.textContent = '⟳ Recalcular agora'; }
  });

  document.getElementById('rep-filter').addEventListener('change', () => loadList());

  await Promise.all([loadStats(), loadList()]);

  async function loadStats() {
    const { data: all } = await db.from('vw_reposicao_sugerida').select('situacao,classe_abc,qtd_repor_sugerida,valor_estoque');
    const total = (all || []).length;
    const critico = (all || []).filter(r => r.situacao === 'critico').length;
    const alerta = (all || []).filter(r => r.situacao === 'alerta').length;
    const atencao = (all || []).filter(r => r.situacao === 'atenção').length;
    const ok = (all || []).filter(r => r.situacao === 'ok').length;
    const qtdRepor = (all || []).reduce((a, r) => a + Number(r.qtd_repor_sugerida || 0), 0);
    document.getElementById('rep-stats').innerHTML = `
      <div class="stat ${critico>0?'danger':'success'}"><div class="label">Críticos</div><div class="value">${NUM(critico)}</div><div class="delta">&lt; 50% mín.</div></div>
      <div class="stat ${alerta>0?'warning':''}"><div class="label">Alerta</div><div class="value">${NUM(alerta)}</div><div class="delta">&lt; mín.</div></div>
      <div class="stat"><div class="label">Atenção</div><div class="value">${NUM(atencao)}</div><div class="delta">&lt; 120% mín.</div></div>
      <div class="stat success"><div class="label">OK</div><div class="value">${NUM(ok)}</div></div>
      <div class="stat"><div class="label">Total a repor</div><div class="value">${QTY(qtdRepor)}</div><div class="delta">somatório qtd</div></div>
    `;
  }

  async function loadList() {
    const f = document.getElementById('rep-filter').value;
    let q = db.from('vw_reposicao_sugerida').select('*').limit(200);
    if (['critico','alerta','atenção','ok'].includes(f)) q = q.eq('situacao', f);
    else if (['A','B','C'].includes(f)) q = q.eq('classe_abc', f);
    const { data: rows, error } = await q;
    const el = document.getElementById('rep-list');
    document.getElementById('rep-count').textContent = (rows || []).length;
    if (error) { el.innerHTML = `<div class="empty err">${escapeHTML(error.message)}</div>`; return; }
    if (!rows || rows.length === 0) { el.innerHTML = '<div class="empty">Sem dados ainda. Aguardando demanda outbound 90d ou clique em ⟳ Recalcular.</div>'; return; }
    el.innerHTML = `
      <table class="tbl">
        <thead><tr>
          <th>SKU</th><th>Descrição</th><th>Classe</th><th>End.</th>
          <th class="num">Saldo</th><th class="num">Mín</th><th class="num">Máx</th>
          <th class="num">Forecast 30d</th><th class="num">Cobertura</th>
          <th class="num">Repor</th><th>Situação</th>
        </tr></thead>
        <tbody>${rows.map(r => `
          <tr>
            <td class="mono">${escapeHTML(SHORT(r.sku_codigo, 22))}</td>
            <td>${escapeHTML(SHORT(r.descricao || '—', 30))}</td>
            <td><span class="pill ${pillC(r.classe_abc)}">${r.classe_abc || '·'}${r.classe_xyz || ''}</span></td>
            <td class="mono text-sm">${escapeHTML(r.endereco_atual || '—')}</td>
            <td class="num strong">${QTY(r.saldo_atual)}</td>
            <td class="num">${QTY(r.qtd_minima)}</td>
            <td class="num">${QTY(r.qtd_maxima)}</td>
            <td class="num">${QTY(r.forecast_30d)}</td>
            <td class="num">${r.dias_cobertura !== null ? Number(r.dias_cobertura).toFixed(1) + 'd' : '—'}</td>
            <td class="num strong">${QTY(r.qtd_repor_sugerida)}</td>
            <td><span class="pill ${pillS(r.situacao)}">${r.situacao}</span></td>
          </tr>`).join('')}
        </tbody>
      </table>`;
  }
}

function pillC(c) { return c === 'A' ? 'pill-solid-blue' : c === 'B' ? 'pill-blue' : 'pill-mute'; }
function pillS(s) {
  return { critico: 'pill-red', alerta: 'pill-amber', 'atenção': 'pill-amber', ok: 'pill-green' }[s] || 'pill-mute';
}
